<div
    [id]="id + '.' + filter.id"
    class="agpr-filterDuplicates"
    role="radiogroup"
>
    <agpr-radio
        name="filterContent-duplicates-showHide"
        [id]="id + '.' + filter.id + '.show'"
        label="Common.filter.duplicates.show"
        hiddenLabel="Common.filter.duplicates.show"
        [value]="true"
        [(ngModel)]="showDuplicates"
        (ngModelChange)="handleChange()"
    ></agpr-radio>
    <div
        *ngIf="showDuplicates && filter.showGroup"
        class="agpr-filterDuplicates-group"
        [ngClass]="{ 'agpr-filterDuplicates-group--visible': showDuplicates }"
    >
        <agpr-social-switch
            [id]="id + '.' + filter.id + '.group'"
            [(ngModel)]="groupDuplicates"
            (ngModelChange)="handleChange()"
            onText="Common.filter.duplicates.group"
            offText="Common.filter.duplicates.ungroup"
        ></agpr-social-switch>
    </div>
    <agpr-radio
        name="filterContent-duplicates-showHide"
        [id]="id + '.' + filter.id + '.hide'"
        label="Common.filter.duplicates.hide"
        hiddenLabel="Common.filter.duplicates.hide"
        [value]="false"
        [(ngModel)]="showDuplicates"
        (ngModelChange)="handleChange()"
    ></agpr-radio>
</div>
